import axios from "../http";
import rongchuangConstant from "../constants/rongchuang-constant";

const request = {
    getPartnerOrderUnpaid(data = {}) {
        const url = rongchuangConstant.REQ_PARTNER_ORDER_UNPAIDORDER;

        return axios.request({
            url,
            data
        })
    },
}

export default request;
